import { Events } from 'common-tracking';

import { Builder, withGenericClick } from './with-utilities';

const onClickTrackingBuilder: Builder = ({ ref, properties }) => {
  const href = ref.getAttribute('href');
  const event: Events = {
    type: 'click-to-track-paperpal',
    ...properties,
  };
  if (href) {
    event.destination = href;
  }
  return event;
};
export const withOnClickTracking = withGenericClick(onClickTrackingBuilder);
